// App.js
import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";


import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';


// Pages 
import Header from "./components/templates/Header";
import Index from "./components/Index";
import About from "./components/About";
import Contact from "./components/Contact";

import Footer from "./components/templates/Footer";

// Courses Pages 

import Technical_Analysis from "./components/courses/basic-programs/Technical_Analysis";






// CSS 

import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import Refund from "./components/Refund";
import Testimonials from "./components/templates/Testimonials";
import Foundation from "./components/courses/basic-programs/Foundation";
import Future_Options from "./components/courses/basic-programs/Future_Options";
import Adv_Technical_Analysis from "./components/courses/advance-programs/Adv_Technical_Analysis";
import Adv_Options_Strategies from "./components/courses/advance-programs/Adv_Options_Strategies";
import Forex_Trading from "./components/courses/advance-programs/Forex_Trading";
import Courses_Section from "./components/templates/Courses_Section";
import Gallery from "./components/Gallery";
import 'react-image-lightbox/style.css';
import Countdown from "./components/templates/Countdown";
import Why_Us from "./components/Why_Us";
import Stats from "./components/templates/Stats";
import Demo from "./components/courses/Demo";
import Success from "./components/Success";
import Payment from "./components/Payment";

const router = createBrowserRouter([
  {
    path: "/header",
    element: <Header />,
  },
  {
    path:"/footer",
    element:<Footer/>
  },
  {
    path: "/",
    element: <Index />,
  },
  {
    path:"/about",
    element:<About/>
  },
{
  path:"/contact",
  element:<Contact/>
},
{
  path:"/terms",
  element:<Terms/>
},
{
  path:"/privacy",
  element:<Privacy/>
},
{
  path:"/refund",
  element:<Refund/>
},
{
  path:"/reviews",
  element:<Testimonials/>
},
{
  path:"/gallery",
  element:<Gallery/>
},
{
  path:"/course-section",
  element:<Courses_Section/>
},
{
  path:"/countdown",
  element:<Countdown/>
},
{
  path:"/why-us",
  element:<Why_Us/>
},
{
  path:"/stats",
  element:<Stats/>
},
{
  path:"/demo-course",
  element:<Demo/>
},
// **********************

// Courses 

{
  path:"/foundation",
  element:<Foundation/>
},
{
  path:"/technical-analysis",
  element:<Technical_Analysis/>
},
{
  path:"/future-options",
  element:<Future_Options/>
},

// --------------

{
  path:"/advance-technical-analysis",
  element:<Adv_Technical_Analysis/>
},
{
  path:"/advance-options-strategies",
  element:<Adv_Options_Strategies/>
},
{
  path:"/forex-trading",
  element:<Forex_Trading/>
},
{
  path:"/payment-success",
  element:<Success/>
},
{
  path:"/payment",
  element:<Payment/>
}








]);

function App() {


       // On page load or when changing themes, best to add inline in `head` to avoid FOUC
      //  if (localStorage.getItem("theme-color") === "dark" || (!("theme-color" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches)) {
      //   document.documentElement.classList.add("is_dark");
      // } 
      // if (localStorage.getItem("theme-color") === "light") {
      //   document.documentElement.classList.remove("is_dark");
      // } 

  return <RouterProvider router={router} />;
}

export default App;
